import React from "react";
import { Drawer } from "antd";
interface DrawerAntdComponentIF {
  open: boolean;
  setOpen: any;
  title?: any;
  footer?: any;
  children?: any;
  width?: any;
}
const DrawerAntdComponent: React.FC<DrawerAntdComponentIF> = ({
  open,
  setOpen,
  title,
  footer,
  children,
  width,
}: DrawerAntdComponentIF) => {
  return (
    <>
      <Drawer
        closable
        destroyOnClose
        title={title}
        placement="right"
        open={open}
        footer={footer}
        width={width}
        styles={{
          body: {
            height: "100%",
          },
        }}
        onClose={() => setOpen(false)}
      >
        {children}
      </Drawer>
    </>
  );
};

export default DrawerAntdComponent;
